<template>
    <div>
      <modal name="revisar-documento" :width="800" :height="600" :clickToClose="false">
        <div class="modal-content modalContent">
          <span class="closebtn" @click="closeModal">&times;</span>
            <div class="text-center mt-4">
                <h3 class="with-lines">Solicitamos los siguientes documentos</h3>
            </div>
            <div class="row p-4">
                <div class="table-responsive scrollable-content">
                              <table class="table text-center">
                              <thead>
                                  <tr>
                                  <th scope="col">Requisito</th>
                                  <th scope="col">Adjuntar</th>
                                  <th scope="col">Visor</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr  v-for="(result, i) in listArchivos" :key="i">
                                      <!-- <div v-if="result.EstatusArchivo == '2'"> -->
                                      <td style="width: 290px;">{{ result.NombreArchivo }}</td>
                                      <td style="width: 290px;">
                                          <div class="card" style="border-radius: 17px; min-height: 70px;">
                                              <div class="row fila">
                                                  <div class="col-2 pt-3 pl-4">
                                                      <i style="color:rgb(0, 0, 0); " class="far fa-file fa-3x"></i>
                                                  </div>
                                                  <div class="col p-3">
                                                      <h6 class="titulo">Documento</h6>
                                                      <div class="file-select">
                                                          <input @change="onChangeFileDocs($event, result)" type="file" accept="image/*, .pdf, .xml"/>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                          <td style="width: 290px;">
                                              <button @click="mostrarArchivos(result.ArchivoB64, result.tipoArchivo)" type="button" class="btn btn-blue">
                                                  <i  style="color:#fffdfd;" class=" mr-2 far fa-eye"></i>
                                                  Ver
                                              </button>
                                          </td>
                                      <!-- </div> -->
                                  </tr>
                              </tbody>
                              </table>
                          </div>
            </div>
        </div>
        
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    name: 'App',
    props: {
        listArchivos: Array,
    },
    data() {
      return {
      };
    },
    methods: {
      closeModal() {
        this.$modal.hide('revisar-documento');
      },
    }
  };
  </script>
  
  <style >
  .scrollable-content {
    max-height: 500px;
    overflow-y: auto;
  }
  .file-select {
  position: relative;
  display: inline-block;
  cursor: pointer !important;

}

.file-select::before {
  background-color: #ffffff;
  color: rgba(4, 12, 34, 0.664);
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  /* border-radius: 3px; */
  content: 'Seleccionar';
  position: absolute !important;
  left:5% !important;
  top: 20% !important;
  cursor: pointer !important;
}

.file-select input[type="file"] {
  opacity: 0 !important;
  width: 200px !important;
  height: 32px !important;
  display: inline-block !important;
  cursor: pointer !important;
}
    .btn-blue {
  border-radius: 10px;
  background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
  border: #ffffff;
  color: white;
}

.vm--modal {
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-color: white;
  border-radius: 30px !important;
  /* box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4); */
}

.modalContent {
  padding: 15px;
  background-color: white;
  color: white;
  border-radius: 15px;
  position: relative;
  text-align: center;
  border-color: white;
}

.closebtn {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #003c71;
  font-weight: bold;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.closebtn:hover {
  color: #003c718c;
}

.iframe-content {
  width: 100%;
  height: calc(100% - 50px); /* Adjust height to leave space for close button */
  border-color: white;
  border-radius: 0 0 15px 15px; /* Rounded bottom corners */
}

.modal-header {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 15px;
  color: #003c71;
}

.modal-body {
  padding: 20px;
}
  </style>
  